import styled from 'styled-components';
import { Flex, spaceMixin } from '@zillow/constellation';
import { HR } from '@zillow/zrs-comet';

export const StyledFlex = styled(Flex)`
    & > .PaymentTracker-CTA-Button {
        padding-right: ${spaceMixin('xs')};
        :last-child {
            padding-right: 0;
        }
    }
`;

export const StyledHR = styled(HR)`
    && {
        margin: ${spaceMixin('sm')} 0;
    }
`;

export const StyledFlexPointerCursor = styled(Flex)`
    cursor: pointer;
`;
